<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Mrme0O/tc-custom/9781504085861.jpg?1704273847468" alt="This image is the cover for the book Charcoal House"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Charcoal House
      </h1>
      <p class="bookDescription body article font2">
        <b>In a house filled with darkness, a woman battles to find her way out . . .</b><br/><br/> After a seemingly perfect start to their relationship, Emma marries Simon. But as soon as they return from the honeymoon, Simon changes. He forbids Emma from seeing her friends and parents. He controls their finances. And through a series of cruel, unexplained incidents, he persuades her that she’s losing her mind.<br/><br/> With Emma’s spirit battered and her passion for painting destroyed after a few months of marriage, she finally admits to herself that she’s afraid of her husband. The only piece she manages to complete is of a depressing charcoal house, a representation of her tortured life. Then Emma receives a cryptic message from a stranger—and shocking revelations begin to emerge one by one.<br/><br/> When the police become involved, events spiral out of control, and Emma’s loved ones do all they can to help her escape the monster’s clutches—but is it already too late to save her?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gillian Jackson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48df697c